module.exports = __webpack_public_path__ + "static/media/56.8b10eb5a.jpg";